import LineHeight3 from '@assets/icons/line-height-3.svg'
import { Icon } from './Icon'

export const LineHeight3Icon = Icon(LineHeight3)
